import { createAction, props } from '@ngrx/store';

export const fetchCampusesList = createAction(
	'[StateCampusLocations/API] Fetch Campuses List',
	props<any>(),
);

export const updateCampusesList = createAction(
	'[StateCampusLocations/API] Update Campuses List',
	props<any>(),
);

export const updateCampusLocationsUniversityUrl = createAction(
	'[StateCampusLocations/API] Update Campus Locations University Url',
	props<{ universityUrl: string }>(),
);

export const loadStateCampusLocationsFailure = createAction(
	'[StateCampusLocations/API] Load StateCampusLocations Failure',
	props<{ error: any }>(),
);
